// @flow

import * as React from 'react';

import Details from '@screens/HowItWorks/components/MiniFlow/Details';
import NewPatientUpload from '@screens/HowItWorks/components/MiniFlow/newPatientDocumentUpload';

import { DarkCrossIcon } from '@images/svg/index';

import FlowModal from '@components/FlowModal/index';
import { StyledModalWrapper, StyledOuterModalWrapper, StyledIconWrapper } from './styles';
import type { modalProps } from './types';

const Modal = ({ modalState, handleOpen, signUp }: modalProps): React.Node => {
  const [modalSlide, setModalSlide] = React.useState(0);

  const [visible, setVisible] = React.useState(true);

  const [contactUs, setContactUs] = React.useState(false);

  // React.useEffect(() => {
  //   setModalSlide(0);
  // }, [modalState]);
  return (
    <StyledOuterModalWrapper modalState={modalState}>
      <StyledModalWrapper modalState={modalState}>
        <StyledIconWrapper modalState={modalState}>
          <DarkCrossIcon
            onClick={() => {
              handleOpen(false);
              setVisible(true);
              setModalSlide(0);
            }}
          />
        </StyledIconWrapper>

        {visible && (
          <FlowModal
            isActive={modalSlide === 0}
            setModalSlide={setModalSlide}
            modalSlide={modalSlide}
            setVisible={setVisible}
            handleOpen={handleOpen}
            setContactUs={setContactUs}
          />
        )}

        <Details
          isMobile={false}
          isActive={modalSlide === 1}
          setSuccess={() => {}}
          clickEvent={() => {}}
          treatmentPage=""
          signUp={signUp}
          onTimeSelect={() => {}}
          isModal
          modalState={modalState}
          setModalSlide={setModalSlide}
          contactUs={contactUs}
        />
        <NewPatientUpload
          isActive={modalSlide === 2 || modalSlide === 3}
          setSuccess={() => {}}
          formName="FinderForm"
          onTimeSelect={() => {}}
          isModal
          modalState={modalState}
        />
      </StyledModalWrapper>
    </StyledOuterModalWrapper>
  );
};

export default Modal;
